// Header.jsx
import { useEffect, useState } from "react";
import ProfileDialog from '../profile/ProfileDialog';
import OrganisationSelectorDialog from '../organisation/OrganisationSelectorDialog';
import {
  IDSHeaderInera,
  IDSHeaderIneraItem,
  IDSHeaderIneraNav,
  IDSHeaderIneraNavItem,
  IDSLink,
} from "@inera/ids-react";

import { useOrganisation } from "../../contexts/OrganisationContext";
import { useLocation, useNavigate } from "react-router";
import { formatRoleName } from "../../utils/tokenUtils";

const Header = () => {
  const { activeRoleId, activeOrgId, organisations, openSelector } = useOrganisation();
  const activeOrganisation = organisations.find(o => o.id === activeOrgId);
  const isAdmin = activeRoleId === "inera-administrator";
  const isE2EUser = activeRoleId?.toLowerCase().endsWith("-e2e-tester");
  const isE2EReviewer = activeRoleId?.toLowerCase().endsWith("-e2e-reviewer");
  const isReviewer = activeRoleId === "inera-reviewer";
  const navigate = useNavigate();
  const location = useLocation();
  const [profileOpen, setProfileOpen] = useState(false);

  // Handle navigation clicks
  const handleNavigation = (e, path) => {
    e.preventDefault();
    navigate(path);
    // Close mobile menu after navigation
    document.body.click();
  };

  // Close menus on route change
  useEffect(() => {
    const headerElement = document.querySelector("ids-header-inera");
    if (headerElement) {
      document.body.click();
    }
  }, [location.pathname]);

  return (
    <>
      <OrganisationSelectorDialog />
      <ProfileDialog isOpen={profileOpen} onClose={() => setProfileOpen(false)} />
      <IDSHeaderInera
      items={
        <>
          <IDSHeaderIneraItem icon="user">
            <button
              onClick={(e) => { e.preventDefault(); openSelector(); }}
            >
              {activeOrganisation && activeRoleId
                ? `${activeOrganisation.displayName ?? activeOrganisation.name} · ${formatRoleName(activeRoleId)}`
                : "Välj roll"}
            </button>
          </IDSHeaderIneraItem>
          <IDSHeaderIneraItem icon="user">
            <button onClick={() => setProfileOpen(true)}>
              Profil
            </button>
          </IDSHeaderIneraItem>
          <IDSHeaderIneraItem mobile icon="activity">
            <a href="/logout" onClick={(e) => handleNavigation(e, "/logout")}>
              Logga ut
            </a>
          </IDSHeaderIneraItem>
        </>
      }
    >
      <IDSHeaderIneraNav>
        <IDSHeaderIneraNavItem>
          <a href="/start" onClick={(e) => handleNavigation(e, "/start")}>
            Start
          </a>
        </IDSHeaderIneraNavItem>
        {!isReviewer && !isAdmin && !isE2EUser && !isE2EReviewer && (
          <IDSHeaderIneraNavItem>
            <a
              href="/testklient"
              onClick={(e) => handleNavigation(e, "/testklient")}
            >
              Testklient
            </a>
          </IDSHeaderIneraNavItem>
        )}

        {!isAdmin && !isE2EUser && !isE2EReviewer && (
          <IDSHeaderIneraNavItem>
            <a
              href="/testrapporter"
              onClick={(e) => handleNavigation(e, "/testrapporter")}
            >
              Testrapporter
            </a>
          </IDSHeaderIneraNavItem>
        )}
        {isReviewer && (
          <IDSHeaderIneraNavItem>
            <a
              href="/reviewer/jira-beslut"
              onClick={(e) => handleNavigation(e, "/reviewer/jira-beslut")}
            >
              Jira beslutskö
            </a>
          </IDSHeaderIneraNavItem>
        )}
        {isE2EUser && (
          <IDSHeaderIneraNavItem>
            <a href="/e2e/tester" onClick={(e) => handleNavigation(e, "/e2e/tester")}>
              E2E Underlag
            </a>
          </IDSHeaderIneraNavItem>
        )}
        {isE2EUser && (
          <IDSHeaderIneraNavItem>
            <a href="/e2e/tester/submissions" onClick={(e) => handleNavigation(e, "/e2e/tester/submissions")}>
              Inlämnade E2E underlag
            </a>
          </IDSHeaderIneraNavItem>
        )}
        {isE2EReviewer && (
          <IDSHeaderIneraNavItem>
            <a href="/e2e/reviewer" onClick={(e) => handleNavigation(e, "/e2e/reviewer")}>
              E2E Granskarportal
            </a>
          </IDSHeaderIneraNavItem>
        )}
        {isAdmin && (
          <IDSHeaderIneraNavItem
            label="Administration"
            col1={[
              <IDSLink key="orgs" activeIcon block menu>
                <a
                  href="/organisations"
                  onClick={(e) => handleNavigation(e, "/organisations")}
                >
                  Organisationer
                </a>
              </IDSLink>,
              <IDSLink key="users" activeIcon block menu>
                <a
                  href="/users"
                  onClick={(e) => handleNavigation(e, "/users")}
                >
                  Användare
                </a>
              </IDSLink>,
              <IDSLink key="departments" activeIcon block menu>
                <a
                  href="/departments"
                  onClick={(e) => handleNavigation(e, "/departments")}
                >
                  Avdelningar
                </a>
              </IDSLink>,
              <IDSLink key="orders" activeIcon block menu>
                <a
                  href="/serviceorders"
                  onClick={(e) => handleNavigation(e, "/serviceorders")}
                >
                  Beställningar
                </a>
              </IDSLink>,
              <IDSLink key="questions" activeIcon block menu>
                <a
                  href="/editquestions"
                  onClick={(e) => handleNavigation(e, "/editquestions")}
                >
                  Ändra frågor
                </a>
              </IDSLink>,
              <IDSLink key="contracts" activeIcon block menu>
                <a
                  href="/editcontracts"
                  onClick={(e) => handleNavigation(e, "/editcontracts")}
                >
                  Ändra kontrakt
                </a>
              </IDSLink>,
              <IDSLink key="tkb" activeIcon block menu>
                <a
                  href="/tkb-admin"
                  onClick={(e) => handleNavigation(e, "/tkb-admin")}
                >
                  TKB-dokument
                </a>
              </IDSLink>,
            ]}
          />

        )}
      </IDSHeaderIneraNav>
    </IDSHeaderInera>
    </>
  );
};

export default Header;
